import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './modules/layouts/admin/admin-layout/admin-layout.component';
import { AuthGuard } from './modules/core/guards/auth.guard';
import { RoleGuard } from './modules/core/guards/role.guard';
import { QRValidateComponent } from './modules/business/qr-validate/qr-validate.component';
import { PaymentStatusComponent } from './modules/payments/payment-status/payment-status.component';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/layouts/landing/landing.module').then(
        (m) => m.LandingModule
      ),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/layouts/admin/admin.module').then(
        (m) => m.AdminModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(
        (m) => m.AuthModule
      ),
  },
  {
    path: 'company',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/business/business.module').then(
        (m) => m.BusinessModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['CLIENT'] }
  },
  {
    path: 'backoffice',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/backoffice/backoffice.module').then(
        (m) => m.BackofficeModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'users',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/user/user.module').then(
        (m) => m.UserModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'validate/certificate',
    component: QRValidateComponent
  },
  {
    path: 'validate/license',
    component: QRValidateComponent
  },
  {
    path: 'payment/status/:reference',
    component: PaymentStatusComponent
  },
  {
    path: 'payment',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/payments/payments.module').then(
        (m) => m.PaymentsModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'licensing',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./modules/licensing/licensing.module').then(
        (m) => m.LicensingModule
      ),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '' }
];
